import React, {useMemo, useState} from "react";

export default function ConfirmModal({title, messages, hideDays=0, _onClose=undefined, _onConfirm=undefined}) {
    const[showModal, setShowModal] = useState(getCookie(title.replace(/ /g,"_")+'_modal') ? false : true);

    const rows = useMemo(() => {
        const rows = messages.map((node, i) =>
            (<p key={i}>
                {node}
                <br/>
            </p>)
        )
        return rows;
    }, [messages]);

    // On dismiss
    const _onModalClose = (e) => {
        if(_onClose != undefined) _onClose();
    };

    // On Confirm
    const _onModalConfirm = (e) => {
        if(_onConfirm != undefined) _onConfirm();
        if(hideDays > 0) {
            setCookie(title.replace(/ /g, "_") + '_modal', 1, hideDays);
            setShowModal(false);
        }
    };

    return showModal &&
        <div
            className="modal fade show"
            tabIndex="-1"
            style={{
                display: "block",
                background: "rgba(0,0,0,0.75)"
            }}
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title">{title}</h3>
                    </div>

                    <div className="modal-body">
                        {rows}
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            data-bs-dismiss="modal"
                            onClick={(e) => {
                                _onModalClose(e);
                            }}
                        >
                            Go Back
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={(e) => {
                                _onModalConfirm(e);
                            }}
                        >
                            Ok, I Understand
                        </button>
                    </div>
                </div>
            </div>
        </div>
}